export default "__VITE_ASSET__DokuOAZI__"